<template>
  <OArticleCard v-bind="$attrs" class="bg-white w-full sm:w-[350px] rounded-none sm:rounded-md flex flex-col">
    <OArticleCover :width="isMobile ? '100%' : 350" class="flex-shrink-0 rounded-none sm:rounded-t-md" />
    <OArticleBadge pin="left" />
    <div class="flex flex-col p-4 flex-grow">
      <div class="flex-grow">
        <OArticleTitle :level="3" class="hover:text-link-primary line-clamp-3 mb-3" />
      </div>
      <div class="flex">
        <OArticleHashtag class="mr-auto z-2" />
        <OArticleCategory class="ml-auto z-2" />
      </div>
    </div>
  </OArticleCard>
</template>

<script>
import { defineComponent } from '@nuxtjs/composition-api';
import { useDevice } from '@/composables/useDevice';
import OArticleCard from '@/modules/card/components/ArticleCard';
import OArticleCover from '@/modules/card/components/ArticleCover';
import OArticleTitle from '@/modules/card/components/ArticleTitle';
import OArticleCategory from '@/modules/card/components/ArticleCategory';
import OArticleBadge from '@/modules/card/components/ArticleBadge';
import OArticleHashtag from '@/modules/card/components/ArticleHashtag';

export default defineComponent({
  components: {
    OArticleCard,
    OArticleCover,
    OArticleTitle,
    OArticleCategory,
    OArticleBadge,
    OArticleHashtag,
  },
  inheritAttrs: false,
  setup() {
    const { isMobile } = useDevice();
    return { isMobile };
  },
});
</script>
